import { Download, ExternalLink, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";

const links = [
  { id: "calculator", label: "Calculator" },
  { id: "results", label: "Estimate" },
  { id: "materials", label: "Materials" },
  { id: "comparison", label: "Compare Cities" },
  { id: "milestones", label: "Payments" },
  { id: "emi", label: "EMI" },
  { id: "pmay", label: "PMAY Subsidy" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Navbar = ({ onDownload, canDownload }) => {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="sticky top-0 z-50 w-full border-b border-slate-800/80 bg-slate-950/80 backdrop-blur-xl no-print"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          href="/"
          className="flex items-center gap-2.5 group"
          data-testid="brand-logo"
        >
          <img
            src="/nirmandwar_logo_mark.png"
            alt="NirmanDwar logo"
            className="h-10 w-10 rounded-full bg-white object-cover ring-2 ring-orange-500/40 shadow-lg shadow-orange-500/20 group-hover:scale-105 transition-transform"
          />
          <div className="leading-none">
            <span className="font-heading font-extrabold text-lg text-white tracking-tight">
              Nirman<span className="text-orange-500">Dwar</span>
              <sup className="text-[0.5em] font-semibold text-orange-400 ml-0.5">™</sup>
            </span>
            <span className="hidden sm:block text-[10px] font-mono-data lowercase tracking-widest text-slate-500">
              nirmandwar.com
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-${l.id}`}
              className="px-3 py-2 text-sm font-medium text-slate-300 hover:text-white hover:bg-slate-800/60 rounded-lg transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="https://nirmandwar.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="link-nirmandwar"
            className="hidden md:inline-flex items-center gap-1.5 text-sm font-medium text-slate-400 hover:text-orange-400 transition-colors px-2"
          >
            nirmandwar.com <ExternalLink className="h-3.5 w-3.5" />
          </a>
          <Button
            onClick={onDownload}
            disabled={!canDownload}
            data-testid="btn-download-pdf"
            className="bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-xl gap-2"
          >
            <Download className="h-4 w-4" />
            <span className="hidden sm:inline">Download PDF</span>
          </Button>
          <button
            className="lg:hidden p-2 text-slate-300"
            onClick={() => setOpen(!open)}
            data-testid="btn-mobile-menu"
          >
            <Menu className="h-5 w-5" />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-800 bg-slate-950 px-4 py-3 space-y-1">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => {
                scrollTo(l.id);
                setOpen(false);
              }}
              className="block w-full text-left px-3 py-2.5 text-sm font-medium text-slate-300 hover:bg-slate-800 rounded-lg"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
